(function ($) {

    "use strict";

    $.enhancer("arrangementFilter", {

        init: function init(el) {

            this.element = $(el);
            this.terms = this.element.find("input[data-arrangementFilter-term]");
            this.parameterName = this.element.attr('data-arrangementFilter-parameter-name');
            this.clearButton = this.element.find("[data-arrangementFilter-clear-button]");

            var enhancer = this;

            this.setFilterValue(this.getSelectedTermsValues().join(","));

            this.terms.on("change", function (e, propagate) { enhancer.termChanged(e, propagate); });

            this.clearButton.on("click", function () { enhancer.clear(); });

        },

        getSelectedTerms: function getSelectedTerms() {
            return this.terms.filter(":checked");
        },

        getSelectedTermsValues: function getSelectedTermsValues() {
            return this.getSelectedTerms().map(function () {
                return $(this).val()
            }).get();
        },

        setFilterValue: function setFilterValue(value) {
            if (value) {
                this.clearButton.show();
            } else {
                this.clearButton.hide();
            }
            this.element.attr("data-arrangmentFilter-filterValue", value);
            // console.log("setFilterValue: ", this.element.attr("data-arrangmentFilter-filterValue"));
        },

        clear: function clear() {
            this.clearButton.hide();
            this.terms.prop("checked", false);
            this.raiseTermChanged();
        },

        termChanged: function termChanged(e, propagate = true) {
            var source = e.currentTarget;

            // Get all inputs that has the same name and value
            var targets = $("input[name='" + source.name + "'][value='" + source.value + "']").not(source);

            // console.log("termChanged", propagate, source, $(source).is(":checked"), targets);

            // And set the same checked status on that
            targets.prop("checked", source.checked);

            if (source.checked) {
                // Uncheck any subterms
                $("input[data-parent='" + source.value + "']").prop("checked", false);
                // If term has a parent, then uncheck this
                if (source.dataset.parent) {
                    $("input[value='" + source.dataset.parent + "']").prop("checked", false);
                }
            }

            // If the event should propagate, ie. be triggered on the target as well then do that, but don't propagate recursively
            if (propagate) {
                targets.trigger("change", false);
            }

            this.raiseTermChanged(propagate);

        },

        raiseTermChanged: function (triggerFilterChangeEvent = true) {
            var filterValue = this.getSelectedTermsValues().join(",");
            var eventData = { parameterName: this.parameterName, value: filterValue };
            this.setFilterValue(filterValue);

            console.log("raiseTermChanged", filterValue, eventData);

            if (triggerFilterChangeEvent) {
                this.element.trigger("arrangementFilterChanged", [eventData]);
            }
        }

    });

}) (jQuery);